import * as styles from './style.css';

export function SignInBackgroundArts() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.steamOrb1} />
      <div className={styles.steamOrb2} />
      <div className={styles.steamOrb3} />
    </div>
  );
}
